/**
 * Safely extracts attorney ID from either a string UUID or an attorney object
 * This prevents [object Object] being sent to API endpoints
 */
export function extractAttorneyId(value: unknown): string | null {
  if (!value) return null;

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object' && value !== null && 'id' in value) {
    return (value as { id: string }).id;
  }

  return null;
}
